(() => {
  class EZProductCarousel extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const opts = { signal: this.abort.signal };
      this.track = this.querySelector('.ez-tile-grid');
      this.items = [...this.track.querySelectorAll('.ez-tile')];
      this.allItems = [...this.items];
      this.index = 0;
      this.querySelector('[data-product-controls]').hidden = false;
      this.querySelector('[data-product-prev]').addEventListener('click', () => this.move(-1), opts);
      this.querySelector('[data-product-next]').addEventListener('click', () => this.move(1), opts);
      this.querySelector('[data-product-filter]').addEventListener('change', e => {
        this.finish?.();
        this.allItems.forEach(item=>item.remove());
        this.items=this.allItems.filter(item=>e.target.value==='all'||item.dataset.blockId===e.target.value);
        this.index=0;this.order();
      },opts);
      this.addEventListener('touchstart', e => { this.start = {x:e.touches[0].clientX,y:e.touches[0].clientY}; }, {...opts,passive:true});
      this.addEventListener('touchend', e => {
        if (!this.start) return;
        const dx=e.changedTouches[0].clientX-this.start.x,dy=e.changedTouches[0].clientY-this.start.y;
        if (Math.abs(dx)>45 && Math.abs(dx)>Math.abs(dy)) this.move(dx<0?1:-1);
        this.start=null;
      }, opts);
      this.addEventListener('shopify:block:select', e => {
        if (this.busy) this.finish?.();
        const index=this.items.findIndex(item=>item.dataset.blockId===e.detail.blockId);
        if(index>=0) { this.index=index;this.order(); }
      },opts);
      this.classList.add('is-ready');
      this.order();
    }
    order() {
      if(!this.items.length) return;
      this.items.forEach((_,i)=>this.track.append(this.items[(this.index+i)%this.items.length]));
      this.track.style.transform='';
      this.track.style.transition='none';
      this.querySelector('[data-product-controls]').hidden=this.items.length<2;
      const status=this.querySelector('[data-product-status]');
      status.textContent=`${this.index+1} / ${this.items.length}`;
      this.querySelector('[data-product-progress]').style.setProperty('--product-index',this.index);
      this.querySelector('[data-product-progress]').style.setProperty('--product-count',this.items.length);
    }
    move(direction) {
      if(this.busy || this.items.length<2) return;
      this.busy=true;
      const step=this.items[0].getBoundingClientRect().width+parseFloat(getComputedStyle(this.track).gap || 0);
      const clone=(direction>0?this.track.firstElementChild:this.track.lastElementChild).cloneNode(true);
      clone.inert=true;clone.setAttribute('aria-hidden','true');clone.removeAttribute('data-shopify-editor-block');
      clone.querySelectorAll('[id]').forEach(e=>e.removeAttribute('id'));
      this.track.style.transition='none';
      if(direction>0) this.track.append(clone);
      else { this.track.prepend(clone);this.track.style.transform=`translateX(-${step}px)`; }
      this.track.getBoundingClientRect();
      this.track.style.transition=matchMedia('(prefers-reduced-motion: reduce)').matches?'none':'transform 450ms ease';
      this.track.style.transform=direction>0?`translateX(-${step}px)`:'translateX(0)';
      this.finish=()=>{
        clearTimeout(this.timer);clone.remove();
        this.index=(this.index+direction+this.items.length)%this.items.length;
        this.order();this.busy=false;this.finish=null;
      };
      this.timer=setTimeout(()=>this.finish?.(),460);
    }
    disconnectedCallback() { this.abort?.abort();this.finish?.();clearTimeout(this.timer); }
  }
  if(!customElements.get('ez-product-carousel')) customElements.define('ez-product-carousel',EZProductCarousel);
})();
